import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconHeartCircleStack32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconHeartCircleStack32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M23.993 23.993A11.49 11.49 0 0 1 14.5 29C8.149 29 3 23.851 3 17.5a11.49 11.49 0 0 1 5.007-9.493A11.49 11.49 0 0 1 17.5 3C23.851 3 29 8.149 29 14.5c0 3.942-1.983 7.421-5.007 9.493m1.92-5.078A9.46 9.46 0 0 0 27 14.5 9.5 9.5 0 0 0 17.5 5a9.46 9.46 0 0 0-4.415 1.086Q13.78 6 14.5 6C20.851 6 26 11.149 26 17.5q-.001.72-.086 1.415M14.5 27a9.5 9.5 0 1 0 0-19 9.5 9.5 0 0 0 0 19m-3.946-11.96c-.642.642-.702 1.172-.568 1.742.172.733.722 1.626 1.591 2.582.84.925 1.833 1.749 2.64 2.354l.283.209.284-.21c.806-.604 1.798-1.428 2.639-2.353.87-.956 1.418-1.85 1.59-2.582.135-.57.074-1.1-.567-1.741-.427-.427-.684-.462-.763-.468-.113-.009-.291.02-.555.172a3.4 3.4 0 0 0-.725.599 4 4 0 0 0-.261.31l-.003.005a2 2 0 0 1-3.278 0l-.003-.005-.045-.059a4 4 0 0 0-.216-.251 3.3 3.3 0 0 0-.726-.598c-.263-.153-.441-.182-.554-.173-.079.006-.337.041-.763.468m5.401-1.92c-.89.573-1.455 1.392-1.455 1.392s-.565-.819-1.455-1.392c-1.002-.646-2.417-.982-3.905.506-4.594 4.595 5.36 10.72 5.36 10.72s9.954-6.125 5.36-10.72c-1.488-1.488-2.903-1.152-3.905-.506"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconHeartCircleStack32);
